import { combineReducers } from 'redux';
import { createSimpleToggleReducer } from '../redux-util/general-helpers';
import { TOGGLE_ASSET_STATUS, TOGGLE_STRING_DEBUG } from './dev-keys';

export default combineReducers({
  [TOGGLE_STRING_DEBUG]: createSimpleToggleReducer(TOGGLE_STRING_DEBUG, false),
  [TOGGLE_ASSET_STATUS]: createSimpleToggleReducer(TOGGLE_ASSET_STATUS, false),
});



// WEBPACK FOOTER //
// ./src/app/api/redux-dev/dev-reducer.js